import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from 'hooks';
import {createWebLinkPageLoadingSelector, createWebLinkSubmitStatusSelector, createWebLinkThunk} from 'admin';
import {ICreateWebLinkPayload} from 'models/resources';

export const useCreateWebLink = () => {
  const dispatch = useAppDispatch();
  const loading = useSelector(createWebLinkPageLoadingSelector) as boolean;
  const submitStatus = useSelector(createWebLinkSubmitStatusSelector);
  const createWebLink = useCallback((payload: ICreateWebLinkPayload) => dispatch(createWebLinkThunk(payload)), [
    dispatch,
  ]);

  return {loading, submitStatus, createWebLink};
};
